<template>
  <div>

    <Settings title="List Preferences" prefix="overview" v-if="showFilters" :isCollapsed="false">

      <SettingsPart title="Filter or find factsheets" icon="funnel" note="Tip: Pressing [Esc] clears active filters">

        <div class="row align-items-center">

          <div class="col">
              <input
                class="form-control"
                @keydown.esc="clearFilters"
                v-model="f_name"
                style="
                  border: 1px solid #ddd;
                  margin-top: 4px;
                  margin-bottom: 6px;
                "
                type="text"
              />
          </div>

        </div>      

        </SettingsPart>
    </Settings>


    <div class="row" style="margin: 0px -8px;margin-top:15px;">
      <Item
        v-for="item in filteredFactsheets"
        :item="item"
        :key="item.identifier"
      ></Item>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Item from "@/components/home/user/Item.vue";
import Settings from "@/components/generic/ui/Settings.vue"
import SettingsPart from "@/components/generic/ui/SettingsPart.vue"

export default {
  props: ["factsheets", "showFilters"],
  data() {
    return {
      f_name: "",
      showFilters: true,
    };
  },
  created() {
    /* Load the main factsheet information via the factsheet API */
    //this.loadFactsheetList();
  },
  components: {
    Item, Settings, SettingsPart
  },
  mounted() {},
  computed: {
    filteredFactsheets() {
      if (this.f_name != "") {
        return this.factsheets.filter((item) =>
          item.search_str.match(this.f_name.toLowerCase())
        );
      } else {
        return this.factsheets;
      }
    },
    filtersApplied() {
      return this.f_name != "";
    },
  },
  watch: {
    f_name: function () {},
  },
  methods: {
    clearFilters() {
      this.f_name = "";
    },
  },
  name: "FactsheetCollection",
};
</script>

<style></style>

<style scoped>
input {
  border-radius: 0px;
  padding: 2px;
}
h2 {
  font-size: 1.5em;
  font-weight: 600;
  color: #666;
}
h4 {
  padding-left: 5px;
}
a.item-project {
  font-size: 1.35em;
  padding: 7px;
  border: 1px solid #ddd;
  background-color: #f9f9f9;
  display: block;
  width: 100%;
  height: 125px;
  margin-bottom: 15px;
}
a.item-project:hover {
  border-color: #ccc;
  background-color: #fff;
}
a.item-project p {
  margin: 5px 0px;
  font-size: 0.8em;
  display: -webkit-box;
  max-width: 400px;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.list-group-item {
  border-radius: 0px;
  padding: 9px;
}
.list-group-item.active {
  background-color: #cce5ff;
}
.list-group-item h5 {
  color: #007bff;
}
a.list-group-item:hover h5 {
  color: #0056b3;
}
.selected {
  background-color: #f5f5f5;
}
.selected h5 {
  font-weight: bold;
}
ul.items {
  border: 0;
  margin: 0;
  padding: 0;
}
p {
  color: #666;
  font-size: 1.2em;
}
.btn-alt {
  background-color:#fff;
  color:#666;
  border:1px solid #ccc;

}
</style>
